<template>
    <div class="quick-entry-process">
        <!-- 流程 -->
        <div class="process-entry">
            <!-- 审批流 -->
            <div v-if="mode===1" class="approve-process" v-loading="loadingApprove">
                <div class="approve-list">
                    <div class="approve-list-item" v-for="(item,index) in approveList" :key="index">
                         <div class="content">
                             <span class="name">{{item.templateName}}</span>
                         </div>
                         <div class="bottom">
                             <div class="pre" @click="previewApprove(item)">查看预览</div>
                             <div class="send-approve" @click="sendApprove(item)">发起审批</div>
                         </div>
                    </div>
                </div>
            </div>
            <!-- 业务流 -->
            <div v-if="mode===2" class="business-process" v-loading="loadingBusiness">
                <div class="business-list">
                   <div class="business-list-item" v-for="(item,index) in processList" :key="index">
                        <div class="content">
                           <span class="name">{{item.templateName}}</span>
                        </div>
                        <div class="bottom">
                            <el-badge class="badge-item" v-permission="permission.previewProcessTemplateBtn">
                                <div class="pre" @click="previewProcess(item)">查看预览</div>
                            </el-badge>
                             <div class="flow" @click="previewProcessImg(item)">流程图</div>
                            <el-badge class="badge-item" v-permission="permission.startProcessTemplateBtn">
                               <div class="send-approve" @click="sendProcess(item)">发起流程</div>
                            </el-badge>
                        </div>
                   </div>
                </div>
            </div>
        </div>
        <el-dialog  :visible.sync="isShowApproveList">
            <div>
               <el-steps :active="approveUserList.length" align-center>
                  <el-step v-for="(item,index) in approveUserList" :key="index"  :title="item.trueName"></el-step>
                </el-steps>
            </div>
        </el-dialog>
        <el-dialog
            :title="approvalTitle"
            width="80%"
            top="0vh"
            append-to-body
            class="approval-pop-dialog"
            :visible.sync="isShowApprovalPop"
            :fullscreen=true
            >
            <ApprovalPop
                    :key="loadTimer"
                    ref="approvalPop"
                    :instances="{id:approvalInstanceId,formObj: {}}"
                    :isInstance="false"
                    :approvalTemplateObj="templateInfo"
                    :busiProcessInstanceId="busiProcessInstanceId"
                    :busiProcessInstanceName="busiProcessInstanceName"
                    :busiTaskInstanceId="busiTaskInstanceId"
                    :belongProcessFlag="belongProcessFlag"
                    :formDataFromBusiness="formInfo"
                    :taskParam="taskParam"
                    :processModelFormsObj="processModelFormsObj"/>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleSaveDraft"  type="success">保存草稿</el-button>
                <el-button @click="handleApply" :loading="startApprovalloading" type="primary">发起审批</el-button>
                <el-button @click="isShowApprovalPop=false" type="info">取 消</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="流程预览"
            width="80%"
            append-to-body
            :fullscreen=true
            :visible.sync="isShowSetting"
            >
            <ProcessSetting
              :key="loadTimer"
              :processInstance="processInstance"
              :taskList="taskList"
              :archiveTemplateTreeList="archiveTemplateTreeList"
            />
            <span slot="footer" class="dialog-footer">
                <el-button @click="isShowSetting=false">取 消</el-button>
            </span>
        </el-dialog>
        <el-dialog
            class='processPopClass'
            title="启动流程"
            top="0vh"
            width="80%"
            append-to-body
            :visible.sync="isShowStartProcessDialog">
            <ProcessInstancePop :key="loadTimer" ref="processInstancePop" :fromWorkAssistant="true"  @handleClosePop="handleClosePop"/>
        </el-dialog>
        <!-- 显示详细 -->
        <el-dialog
            title="流程明细"
            :fullscreen=true
            append-to-body
            :visible.sync="isShowDiagram"
            custom-class="diagram-dialog">
            <ProcessDetailView ref="detailView" :viewParams="viewParams" />
        </el-dialog>
    </div>
</template>

<script>
    import { isEmpty } from 'lodash';
    import ProcessInstancePop from '@/pages/process/ProcessTemplate/ProcessInstancePop';
    import {getApprovalTemplateList, getProcessTemplateList, getAllUserTask, getArchiveTemplateTreeList} from '@/data-model';
    import mixinsNav from '@/mixins/mixins-nav';
    import ProcessDetailView from '@/pages/process/ProcessList/ProcessDetailView';
    import { CONST_PERMISSION_PROCESS_START_PROCESS_TEMPLATE_BTN,
        CONST_PERMISSION_PROCESS_DESIGN_PROCESS_TEMPLATE_BTN,
        CONST_PERMISSION_PROCESS_PUBLISH_PROCESS_TEMPLATE_BTN,
        CONST_PERMISSION_PROCESS_PREVIEW_PROCESS_TEMPLATE_BTN,
        CONST_PERMISSION_PROCESS_CONFIG_PROCESS_TEMPLATE_BTN
    } from '@/common/constants';
    export default {
        mixins: [ mixinsNav ],
        components: {
            ProcessInstancePop,
            ProcessDetailView
        },
        props: {
            isFromDashbord: {
                type: Boolean,
                default: false
            },
            mode: {
                type: Number,
                default: 0
            }
        },
        data () {
            return {
                formInfo: {},
                searchParams: {
                    busiType: '',
                    busiTypeName: '',
                    templateName: '',
                    templateState: 1,
                    formId: ''
                },
                approveList: [],
                approveUserList: [],
                isShowApproveList: false,
                isShowApprovalPop: false,
                loadTimer: '',
                approvalInstanceId: '',
                templateInfo: {
                    id: '',
                    templateName: '',
                    busiType: '',
                    busiTypeName: '',
                    remarks: '',
                    selectedUser: {
                        selectedUserIds: '',
                        selectedUserNames: ''
                    },
                    templateState: null,
                    forms: [],
                    users: [],
                    approvalList: [[]],
                    dataOperate: {
                        dataSource: 2,
                        forms: []
                    },
                    orderMode: 0,
                    rejectMode: 0,
                    sendSms: 0,
                    clearApprovalUsers: 0,
                    durTime: 0,
                    warnDate: '',
                    selectedCopyUser: {
                        selectedUserIds: '',
                        selectedUserNames: ''
                    },
                    approvalMethod: 1, // 审批方法，1:普通审批，2:审批流节点或签审批
                    showAllMyApprovals: true
                },
                busiProcessInstanceId: '',
                busiProcessInstanceName: '',
                busiTaskInstanceId: '',
                belongProcessFlag: 0,
                taskParam: {},
                processModelFormsObj: [],
                startApprovalloading: false,
                processSearchParams: {
                    key: '',
                    serviceName: '',
                    definitionName: '',
                    state: 1 // 版本范围 ：默认 最新版
                },
                processList: [],
                processInstance: {
                    processServiceName: '',
                    name: ''
                },
                archiveTemplateTreeList: [],
                isShowSetting: false,
                taskList: [],
                isShowStartProcessDialog: false,
                permission: {
                    startProcessTemplateBtn: [
                        CONST_PERMISSION_PROCESS_START_PROCESS_TEMPLATE_BTN
                    ],
                    designProcessTemplateBtn: [
                        CONST_PERMISSION_PROCESS_DESIGN_PROCESS_TEMPLATE_BTN
                    ],
                    publishProcessTemplateBtn: [
                        CONST_PERMISSION_PROCESS_PUBLISH_PROCESS_TEMPLATE_BTN
                    ],
                    previewProcessTemplateBtn: [
                        CONST_PERMISSION_PROCESS_PREVIEW_PROCESS_TEMPLATE_BTN
                    ],
                    configProcessTemplateBtn: [
                        CONST_PERMISSION_PROCESS_CONFIG_PROCESS_TEMPLATE_BTN
                    ]
                },
                approvalTitle: '',
                isShowDiagram: false,
                viewParams: {},
                loadingApprove: false,
                loadingBusiness: false

            };
        },
        created () {
            if (this.approveList.length > 0) {
                if (this.mode === 1) {
                    this.getApproveTemplateList();
                } else if (this.mode === 2) {
                    this.getBusinessTemplateList();
                }
            }
        },
        methods: {
            async getApproveTemplateList () {
                let formData = await getApprovalTemplateList(Object.assign({}, {
                    currentPage: 0,
                    pageSize: '1000'
                }, this.searchParams));
                this.approveList = formData.data;
                this.loadingApprove = false;
            },
            sendApprove (obj) {
                this.approvalTitle = '发起【' + obj.templateName + '】审批申请';
                this.templateInfo = obj;
                this.templateInfo.remarks = '';
                this.templateInfo.selectedUser = {};
                if (!isEmpty(obj.selectedUserIds)) {
                    if (obj.clearApprovalUsers) {
                        this.templateInfo.selectedUser.selectedUserIds = '';
                        this.templateInfo.selectedUser.selectedUserNames = '';
                        this.templateInfo.selectedUserIds = '';
                        this.templateInfo.selectedUserNames = '';
                    } else {
                        this.templateInfo.selectedUser.selectedUserIds = obj.selectedUserIds;
                        this.templateInfo.selectedUser.selectedUserNames = obj.selectedUserNames;
                    }
                } else { // 解决ApprovalPop页面selectedUser.selectedUserNames不能为空的rule提示异常
                    this.templateInfo.selectedUser.selectedUserIds = '';
                    this.templateInfo.selectedUser.selectedUserNames = '';
                }
                this.loadTimer = new Date().getTime();
                this.approvalInstanceId = this.generateUUID();
                setTimeout(() => { // 默认回显值
                    this.$refs.approvalPop._initPage();
                }, 0);
                this.isShowApprovalPop = true;
            },
            previewApprove (obj) {
                if (obj.users && obj.users.length > 0) {
                    this.approveUserList = obj.users;
                    this.isShowApproveList = true;
                } else {
                    this.$message({
                        showClose: true,
                        message: '本条模板没有审批人',
                        type: 'error'
                    });
                }
            },
            async handleSaveDraft () {
                // opType 操作模式：1 保存草稿 2发起审批
                let isToApproval = this.$refs.approvalPop.isToApproval();
                if (!isToApproval) {
                    return;
                }
                let isValid = await this.$refs.approvalPop.handelSaveForms(1);
                // console.log(isValid);
                if (!isValid) {
                    this.isShowApprovalPop = false;
                    sessionStorage.setItem('isShowApprovalDraft', true);
                    if (this.belongProcessFlag === 0) {
                        this.navMyApprovalApplied();
                    } else if (this.belongProcessFlag === 1 || this.belongProcessFlag === 2) {
                        this.$emit('closeApprovalTemplate', {index: '3'});
                    }
                }
            },
            async handleApply () {
                setTimeout(() => { // 默认回显值
                    let isToApproval = this.$refs.approvalPop.isToApproval();
                    if (!isToApproval) {
                        return;
                    }
                    this.hasApplyUser = this.$refs.approvalPop.hasApplyUser();
                    this.$refs.approvalPop.hasRepeatUser();
                    if (this.hasApplyUser) {
                        this.$confirm(`审批人中含有申请人,您确定要发起审批吗？`, '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(async (res) => {
                            this.startApprovalloading = true;
                            let isValid = await this.$refs.approvalPop.handelSaveForms(2);
                            if (!isValid) {
                                this.isShowApprovalPop = false;
                                // console.log("============="+this.belongProcessFlag);
                                if (this.belongProcessFlag === 0) {
                                    this.navMyApprovalApplied();
                                } else if (this.belongProcessFlag === 1 || this.belongProcessFlag === 2) {
                                    this.$emit('closeApprovalTemplate', {index: '0'});
                                }
                            }
                            this.startApprovalloading = false;
                        }).catch(() => {
                        });
                    } else {
                        // opType 操作模式：1 保存草稿 2发起审批
                        this.$confirm(`您确定要发起审批吗？`, '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(async (res) => {
                            this.startApprovalloading = true;
                            let isValid = await this.$refs.approvalPop.handelSaveForms(2);
                            if (!isValid) {
                                this.isShowApprovalPop = false;
                                // console.log("============="+this.belongProcessFlag);
                                if (this.belongProcessFlag === 0) {
                                    this.navMyApprovalApplied();
                                } else if (this.belongProcessFlag === 1 || this.belongProcessFlag === 2) {
                                    this.$emit('closeApprovalTemplate', {index: '0'});
                                }
                            }
                            this.startApprovalloading = false;
                        }).catch(() => {});
                    }
                }, 100);
            },
            generateUUID () {
                var d = new Date().getTime();
                if (window.performance && typeof window.performance.now === 'function') {
                    d += window.performance.now(); // use high-precision timer if available
                }
                var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                    var r = (d + Math.random() * 16) % 16 | 0;
                    d = Math.floor(d / 16);
                    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
                });
                return uuid.replace(RegExp('-', 'g'), '');
            },
            async getBusinessTemplateList () {
                let { data } = await getProcessTemplateList(this.processSearchParams);
                this.processList = data;
                this.loadingBusiness = false;
            },
            async previewProcess (process) {
                let tasks = await getAllUserTask(null, process.processServiceId, process.id, process.deploymentId);
                this.taskList = tasks;
                this.processInstance.id = '-1';
                this.processInstance.processServiceId = process.processServiceId;
                this.processInstance.processServiceName = process.processServiceName;
                this.processInstance.name = process.processServiceName;
                this.processInstance.deploymentId = process.deploymentId;
                this.processInstance.processDefinitionId = process.id;
                // console.log(this.processInstance);
                let treeList = [];
                if (process.archiveTemplateId) {
                    treeList = await getArchiveTemplateTreeList({templateId: process.archiveTemplateId});
                }
                this.archiveTemplateTreeList = treeList;
                this.loadTimer = new Date().getTime();
                this.isShowSetting = true;
            },
            previewProcessImg (obj) {
                this.viewParams.id = obj.processDefinitionId;
                this.viewParams.pModelId = '';
                this.viewParams.viewDiagram = true;
                this.isShowDiagram = true;
                setTimeout(() => {
                    this.$refs.detailView.setProcessState(this.viewParams);
                }, 0);
            },
            sendProcess (process) {
                this.loadTimer = new Date().getTime();
                setTimeout(async () => { // 默认回显值
                    await this.$refs.processInstancePop.handleStartProcess(process);
                }, 0);
                this.isShowStartProcessDialog = true;
            },
            handleClosePop () {
                this.isShowStartProcessDialog = false;
            }
        }
    };
</script>

<style lang="less">
    .quick-entry-process {
        height: 100%;
        width: 100%;
        .entry-top{
            display: flex;
            width: 100%;
            .form-entry{
                height: 280px;
                width: 80%;
                margin-left: 1vw;
                background: #FFFFFF;
                border-radius: 6px;
                margin-top: 10px;
                .form-entry-tit{
                    height: 36px;
                    line-height: 36px;
                    width: 99%;
                    margin-left: 10px;
                    font-size: 1rem;
                    border-bottom: 1px solid #ebeef5;
                    font-weight: bold;
                }
                .form-entry-list{
                    display: flex;
                    flex-wrap: wrap;
                    height: 100%;
                    .form-entry-item{
                        display: inline-block;
                        width: auto;
                        height: 60px;
                        margin-left: 10px;
                        margin-top: 10px;
                        cursor: pointer;
                        background: #FFFFFF;
                        text-align: center;
                        line-height: 60px;
                        padding: 0px 16px 0px 16px;
                        border-radius: 6px;
                        border: 1px solid #e8edf1;
                        .form-add{
                            font-size: 1.75rem;
                            cursor: pointer;
                            margin-left: 8px;
                        }
                        .form-add:hover{
                            color:#00bcd4;
                        }
                    }
                    .form-entry-item:hover{
                        border: 1px solid #00bcd4;
                    }
                }
            }
            .other-entry{
                width: 18%;
                display: flex;
                flex-direction: column;
                margin-left: 10px;
                margin-right: 20px;
                margin-top: 10px;
                .announcement{
                    flex: 1;
                    background: #FFFFFF;
                    padding: 0px 16px 0px 16px;
                    border-radius: 6px;
                    cursor: pointer;
                    text-align: center;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    text-align: justify;
                    font-size: 1.75rem;
                    color: #3f51b5;
                    .icon{
                        width: 2.75rem;
                        height: 2.75rem;
                        .icon-other-fabugonggao{
                            font-size: 2.75rem;
                        }
                        margin-right: 6px;
                    }
                }
                .announcement:hover{
                    border: 1px solid #00bcd4;
                }
                .timed-tasks:hover{
                    border: 1px solid #00bcd4;
                }
                .timed-tasks{
                    flex: 1;
                    background: #FFFFFF;
                    padding: 0px 16px 0px 16px;
                    margin-top: 10px;
                    border-radius: 6px;
                    cursor: pointer;
                    text-align: center;
                    align-items: center;
                    justify-content: center;
                    text-align: justify;
                    display: flex;
                    font-size: 1.75rem;
                    color: #673AB7;
                    .icon{
                        width: 2.65rem;
                        height: 2.65rem;
                        .icon-other-dingshirenwu{
                            font-size: 2.65rem;
                        }
                        margin-right: 6px;
                    }
                }
            }
        }
        .process-entry{
            height: auto;
            display: flex;
            padding-bottom: 20px;
            .approve-process{
                margin-left: 20px;
                border-radius: 6px;
                margin-top: 10px;
                padding-bottom: 10px;
                .approve-entry-tit{
                    height: 36px;
                    line-height: 36px;
                    width: 98%;
                    margin-left: 10px;
                    font-size: 1rem;
                    border-bottom: 1px solid #ebeef5;
                    font-weight: bold;
                }
                .approve-list{
                   display: flex;
                   flex-wrap: wrap;
                   overflow-y: auto;
                   height: auto;
                   padding-bottom: 10px;
                   .approve-list-item{
                       width: 12vw;
                       height: 100px;
                       margin-left: 10px;
                       margin-top: 10px;
                       cursor: pointer;
                       background: #FFFFFF;
                       text-align: center;
                       border-radius: 6px;
                       border: 1px solid #e8edf1;
                       .content{
                           display: flex;
                           height: 70px;
                           line-height: 50px;
                           .name{
                               display: -webkit-box; /*作为弹性伸缩盒子模型显示*/
                               -webkit-line-clamp: 1; /*显示的行数；如果要设置2行加...则设置为2*/
                               overflow: hidden; /*超出的文本隐藏*/
                               text-overflow: ellipsis; /* 溢出用省略号*/
                               -webkit-box-orient: vertical; /*伸缩盒子的子元素排列：从上到下*/
                               flex: 1;
                               text-align: left;
                               margin-left: 10px;
                           }
                       }
                       .bottom{
                            height: 30px;
                            display: flex;
                            .pre{
                                flex: 1;
                                background-color: #ecf5ff;
                                height: 30px;
                                line-height: 30px;
                                text-align: center;
                                font-size: 12px;
                                color: #409eff;
                            }
                            .send-approve{
                                flex: 1;
                                background-color: #fdf6ec;
                                color: #e6a23c;
                                height: 30px;
                                line-height: 30px;
                                text-align: center;
                                font-size: 12px;
                            }
                            .send-approve:hover{
                                background-color: #ffefd9;
                                border: 1px solid #e6a23c;
                            }
                            .pre:hover{
                                background-color: #d8e8fb;
                                border: 1px solid #409eff;
                            }
                       }
                   }
                   .approve-list-item:hover{
                       border: 1px solid #00bcd4;
                   }
                }
            }
            .business-process{
                margin-left: 1vw;
                background: #FFFFFF;
                border-radius: 6px;
                margin-top: 10px;
                padding-bottom: 10px;
                .business-entry-tit{
                    height: 36px;
                    line-height: 36px;
                    width: 98%;
                    margin-left: 10px;
                    font-size: 1rem;
                    border-bottom: 1px solid #ebeef5;
                    font-weight: bold;
                }
                .business-list{
                   display: flex;
                   flex-wrap: wrap;
                   overflow-y: auto;
                   height: auto;
                   padding-bottom: 10px;
                   .business-list-item{
                       width: 12vw;
                       height: 100px;
                       margin-left: 10px;
                       margin-top: 10px;
                       cursor: pointer;
                       background: #FFFFFF;
                       text-align: center;
                       border-radius: 6px;
                       border: 1px solid #e8edf1;
                       .content{
                           display: flex;
                           height: 70px;
                           line-height: 50px;
                           .name{
                               display: -webkit-box; /*作为弹性伸缩盒子模型显示*/
                               -webkit-line-clamp: 1; /*显示的行数；如果要设置2行加...则设置为2*/
                               overflow: hidden; /*超出的文本隐藏*/
                               text-overflow: ellipsis; /* 溢出用省略号*/
                               -webkit-box-orient: vertical; /*伸缩盒子的子元素排列：从上到下*/
                               flex: 1;
                               text-align: left;
                               margin-left: 10px;
                           }
                       }
                       .bottom{
                           height: 30px;
                           display: flex;
                           .badge-item{
                               flex: 1;
                               .pre{
                                   flex: 1;
                                   background-color: #ecf5ff;
                                   height: 30px;
                                   line-height: 30px;
                                   text-align: center;
                                   font-size: 12px;
                                   color: #409eff;
                               }
                               .send-approve{
                                   flex: 1;
                                   background-color: #fdf6ec;
                                   color: #e6a23c;
                                   height: 30px;
                                   line-height: 30px;
                                   text-align: center;
                                   font-size: 12px;
                               }
                               .send-approve:hover{
                                   background-color: #ffefd9;
                                   border: 1px solid #e6a23c;
                               }
                               .pre:hover{
                                   background-color: #d8e8fb;
                                   border: 1px solid #409eff;
                               }
                           }
                           .flow{
                               flex: 1;
                               background-color: #e1feff;
                               color: #0bb7af;
                               height: 30px;
                               line-height: 30px;
                               text-align: center;
                               font-size: 12px;
                           }
                           .flow:hover{
                               flex: 1;
                               background-color: #cbf4f1;
                               color: #00bcd4;
                               border: 1px solid #00bcd4;
                               height: 30px;
                               line-height: 30px;
                               text-align: center;
                               font-size: 12px;
                           }
                       }
                   }
                   .business-list-item:hover{
                        border: 1px solid #00bcd4;
                   }
                }
            }
        }
    }
    .popAddModelDetail {
        .el-dialog__body {
            padding: 5px 30px 0px 0px;
            color: #606266;
            font-size: 14px;
            word-break: break-all;
            height: ~"calc(100% - 8vh)";
        }
    }
    .processPopClass{
      .el-dialog__body {
          padding: 0px 0px;
          color: #606266;
          font-size: 14px;
          word-break: break-all;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/DataWarehousing/QuickEntryProcess.vue